﻿import { Kbo } from "@models/configurators/configurator-di";
import { CToken } from "@models/configurators/ctoken";
import { KbObjectManager } from "@models/configurators/kb-object-manager";
import { KbObject } from "@models/configurators/kb-object";
import { UiObject } from "@models/configurators/ui-object";
import { IManufactureObject } from "..";

@Kbo(CToken.PartOperationDetail)
export class PartOperationDetail extends KbObject implements IManufactureObject {

    public $properties: UiObject[];
    public opDtlDesc: string;
    public resourceID: string;
    public resourceGrpID: string;
    public _metadata: any = {};


    constructor(kom: KbObjectManager, data?: any) {
        super(kom);
        this._metadata = {};

        for (var key in data) {
            let value = data[key];
            if (!Array.isArray(value)) (this as any)[key] = value;
        }
    }

    public getIdentifyingProperty() {
        return (this.resourceGrpID ? "resourceGrpID" : "resourceID");
    }

    public static getMetadataProperties() {
        return [];
    }
}